var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import Dialog from '../../Dialog';
var Content = styled(Dialog.Content)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n  align-self: flex-start;\n  text-align: left;\n"])), function (_ref) {
  var _ref$theme$yoga = _ref.theme.yoga,
      fontWeights = _ref$theme$yoga.fontWeights,
      colors = _ref$theme$yoga.colors,
      lineHeights = _ref$theme$yoga.lineHeights,
      spacing = _ref$theme$yoga.spacing,
      fontSizes = _ref$theme$yoga.fontSizes;
  return "\n    font-weight: " + fontWeights.regular + ";\n    color: " + colors.text.secondary + ";\n    line-height: " + lineHeights.small + "px;\n    margin-bottom: " + spacing.medium + "px;\n    font-size: " + fontSizes.small + "px;\n    ";
});
Content.displayName = 'BottomSheet.Content';
export default Content;